import React, { useContext, useEffect, useState } from 'react';
import '../style/Tabs.css';
import Popup from 'reactjs-popup';
import CalendarPopup from '../modules/popup/CalendarPopup';
import TeamsDataTable from '../modules/datatables/TeamsDataTable';
import MatchDays from '../modules/MatchDays';
import { Col, Row, Tab, Tabs } from 'react-bootstrap';
import {
  fetchFutureMatches,
  fetchSeasons,
  fetchUsers,
} from '../util/api/requests';
import { store } from '../store';
import UpcomingMatchesBasedOnSelectedLeagueDataTable from '../modules/datatables/UpcomingMatchesBasedOnSelectedLeagueDataTable';
import { getUsername, isUserLoggedIn } from './user/User';
import { renderSpinner } from '../util/util';

export const Seasons = () => {
  const [seasons, setSeasons] = useState([]);
  const [currentSeason, setCurrentSeason] = useState();
  const [currentLeague, setCurrentLeague] = useState();
  const [loggedInUserTeamId, setLoggedInUserTeamId] = useState();
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const [loading, setLoading] = useState({ seasons: false, users: false });
  const [futureMatches, setFutureMatches] = useState([]);
  const [FutureMatchesLoading, setFutureMatchesLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setFutureMatchesLoading(true);
      try {
        const futureMatches = await fetchFutureMatches();
        if (futureMatches) {
          setFutureMatches(futureMatches);
        }
      } catch (error) {
        console.error('Error fetching future matches:', error);
      } finally {
        setFutureMatchesLoading(false);
      }
    })();
  }, []);

  function showUpcomingMatchesDatatable() {
    return (
      <UpcomingMatchesBasedOnSelectedLeagueDataTable
        futureMatches={futureMatches}
        leagueId={currentLeague}
      />
    );
  }
  
  function setSeasonAndLeague (seasons) {
    if (!currentSeason || !currentLeague) {
      const selectedSeason = globalState.state.selectedSeason;
      const selectedLeague = globalState.state.selectedLeague;
      
      if (selectedSeason && selectedLeague) {
        const foundSeason = seasons.find((s) => s.id === selectedSeason.id);
        const foundLeague = foundSeason?.leagues.find(
            (l) => l.id === selectedLeague
        );
        setCurrentSeason(foundSeason);
        setCurrentLeague(foundLeague?.id ?? null);
      } else {
        const defaultSeason = seasons[0];
        const defaultLeague = defaultSeason?.leagues[0]?.id ?? 0;
        setCurrentSeason(defaultSeason);
        setCurrentLeague(defaultLeague);
      }
    }
  }

  useEffect(() => {
    (async () => {
      setLoading((loaders) => ({ ...loaders, seasons: true }));
      
      const loadSeasons = async () => {
        if (seasons.length) {
          return seasons;
        }
        
        let loadedSeasons = await fetchSeasons();
        // Sort seasons and leagues
        loadedSeasons.forEach((season) => {
          season.leagues.sort((a, b) => b.name.localeCompare(a.name, 'et'));
        });
        loadedSeasons.sort((a, b) => b.name.localeCompare(a.name, 'et'));
        setSeasons(loadedSeasons);
        return loadedSeasons;
      }

      try {
        const seasons = await loadSeasons();
        setSeasonAndLeague(seasons);
      } catch (error) {
        console.error('Error fetching seasons:', error);
      } finally {
        setLoading((loaders) => ({ ...loaders, seasons: false }));
      }
    })();
  }, []);
  
  useEffect(() => {
    if (!seasons.length) {
      return;
    }
    setSeasonAndLeague(seasons);
  }, [globalState.state.selectedLeague, globalState.state.selectedSeason]);

  useEffect(() => {
    const fetchUserTeam = async () => {
      if (!isUserLoggedIn()) return;

      setLoading((loaders) => ({ ...loaders, users: true }));

      try {
        const users = await fetchUsers();
        if (!users) return;

        const user = users.find((u) => u.username === getUsername());
        setLoggedInUserTeamId(user?.teamId ?? null);
      } catch (error) {
        console.error('Error fetching user team:', error);
      } finally {
        setLoading((loaders) => ({ ...loaders, users: false }));
      }
    };

    fetchUserTeam();
  }, []);

  const handleSeasonChanged = (e) => {
    const season = seasons.find(
      (session) => session.id === Number(e.target.value)
    );
    setCurrentSeason(season);
    if (season.leagues.length) {
      setCurrentLeague(season.leagues[0].id);
      dispatch({
        type: 'SET_SELECTED_STATE',
        state: { selectedSeason: season, selectedLeague: season.leagues[0].id },
      });
    } else {
      dispatch({
        type: 'SET_SELECTED_STATE',
        state: { selectedSeason: season, selectedLeague: currentLeague },
      });
    }
  };

  const handleLeagueChanged = (eventKey) => {
    dispatch({
      type: 'SET_SELECTED_STATE',
      state: {
        selectedSeason: currentSeason,
        selectedLeague: Number(eventKey),
      },
    });
    setCurrentLeague(Number(eventKey));
  };

  if (
    loading.seasons ||
    loading.users ||
    (isUserLoggedIn() && loggedInUserTeamId === undefined)
  ) {
    return renderSpinner();
  }

  return (
    <>
      {seasons?.length ? (
        <div id="select_season">
          <select
            className="form-control"
            value={currentSeason ? currentSeason.id : 0}
            onChange={handleSeasonChanged}
          >
            {seasons.map((season) => (
              <option key={season.id} value={season.id}>
                {season.name}
              </option>
            ))}
          </select>
        </div>
      ) : null}

      <div>
        {currentSeason && currentSeason.leagues ? (
          <Tabs
            className="nav_tabs"
            activeKey={currentLeague}
            onSelect={handleLeagueChanged}
            id="season-tabs"
          >
            {currentSeason.leagues.map((league) => (
              <Tab key={league.id} eventKey={league.id} title={league.name}>
                <Popup
                  trigger={
                    <button className="btn calendar_btn" onClick={() => {}}>
                      {' '}
                      Kalender
                    </button>
                  }
                  modal
                >
                  {(close) => (
                    <CalendarPopup
                      leagueId={league.id}
                      loggedInUserTeamId={loggedInUserTeamId}
                      closeTrigger={close}
                    />
                  )}
                </Popup>
                <div
                  className="justify-content-center"
                  style={{ maxWidth: '700px', margin: 'auto' }}
                >
                  <MatchDays
                    leagueId={league.id}
                    currentSeason={currentSeason}
                  />
                  <br />
                  <TeamsDataTable
                    teams={league.teams}
                    seasonId={currentSeason.id}
                    currentLeagueName={
                      currentSeason.leagues.find((l) => l.id === currentLeague)
                        .name
                    }
                  />
                  <>
                    <Row className={'justify-content-center mt-3 mb-3'}>
                      <Col md={12}>
                        <h3>Järgmised mängud</h3>
                      </Col>
                    </Row>
                    {FutureMatchesLoading
                      ? renderSpinner()
                      : showUpcomingMatchesDatatable()}
                  </>
                </div>
              </Tab>
            ))}
          </Tabs>
        ) : (
          <Row className={'justify-content-center mt-3 mb-3'}>
            <Col md={12}>
              <h3>Andmed puuduvad</h3>
            </Col>
          </Row>
        )}
      </div>
    </>
  );
};
